<template>
  <div>
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />
    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />
    <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />
    

    <confirmPopup
      v-if="popupwindow == true"
      :title="titlepass"
      @cancelClick="popupwindow = false"
      @confirmClick="deletecourse(idpass)"
    />

    <div class="py-3">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-10 mt-10 mb-10">
        <div class="flex flex-col gap-5" v-if="currentBatchData == null">
          <h1 class="text-primary text-xl font-bold">Batches</h1>

          <div class="grid grid-cols-1  md:grid-cols-3 gap-5 mt-5"> 

            <div v-if="loading">
              <p>loading...</p>
            </div>

            <template class="text-center" v-if="batchList.length == 0 && !loading">
              No Batches
            </template>

            <div
              v-for="batch in batchList"
              :key="batch"
              class="flex flex-col py-6 rounded-3xl shadow-xl h-full cursor-pointer"
            >
              <div
                class="lg:px-8 h-full px-6 flex flex-col items-center justify-center gap-4"
              >
                <!-- {{ batch }} -->

                <h1 class="font-bold text-xl lg:text-lg prime text-center">
                  {{ batch.year }} 
                </h1>

                <router-link :to="{ name : 'HodSemesters', params: { batch : batch.id } }"
                  class="bg-blues hover:bg-blue-600 text-sm text-white px-6 py-1.5 rounded-full text-center cursor-pointer"
                >
                  Batch Details
                </router-link>

              </div>
            </div>
          </div>
          
        </div>

        <!-- <div v-if="this.currentSemesterData == null"> 
            <div class="flex flex-col gap-5" v-if="currentBatchData != null">

                <div class="flex cursor-pointer" @click="this.currentBatchData = null"> 
                    <p
                    class="bg-primary text-sm text-white px-6 mt-4 py-1.5 rounded-full text-center cursor-pointer"
                    >
                    Back
                    </p> 
                </div>

                <h1 class="text-primary text-xl font-bold">Semesters of ( {{ currentBatchData.year }} )</h1>
                <div class="grid  grid-cols-1 md:grid-cols-3 gap-5 mt-5">
                    <div
                    v-for="semester in semeterList"
                    :key="semester"
    
                    class="flex flex-col py-6 rounded-3xl shadow-xl h-full cursor-pointer"
                    >
                    <div
                        class="lg:px-8 h-full px-6 flex flex-col gap-4"
                    >
                    
                        <h1 class="font-bold text-lg lg:text-lg prime text-left">
                            Semester {{ semester.semester }}
                        </h1>

                        <p>Batch: {{ currentBatchData.year }} </p>

                        <p>Courses: {{ semester.course.length }}</p>
                        
                        <p
                        @click="getSemesterCourses(semester.id, semester)"
                        class="bg-primary text-white text-sm px-6 mt-4 py-1.5 rounded-full text-center cursor-pointer"
                        >
                        Semester Courses
                        </p>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="flex flex-col gap-5" v-if="currentSemesterData != null">

            <div class="flex justify-between" > 
                <p @click="this.currentSemesterData = null"
                  class="bg-primary text-white px-6 mt-4 py-1.5 rounded-full text-sm text-center cursor-pointer"
                >
                  Back
                </p>  

                <div @click="addCourse = true" class="bg-primary text-sm text-white px-6 mt-4 py-1.5 rounded-full text-center cursor-pointer flex items-center justify-center">
                Add New Course
            </div>

            </div>
           
          <h1 class="text-primary text-xl font-bold">Courses (Sem {{ currentSemesterData.semester }})</h1>

        

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-5">
            <div
              v-for="course in courseList"
              :key="course"
              class="flex flex-col py-6 rounded-3xl shadow-xl h-[400px] cursor-pointer"
            >
              <div
                class="lg:px-8 h-full px-6 flex flex-col gap-4"
              >
                
                <div class="h-[60%]"> 
                  <img :src="course.thumbnail" class="h-[200px] rounded-xl w-full object-cover" alt="">
                  </div>
                
                

                <div class="h-[45%] flex flex-col justify-between"> 
                  <h1 class="font-bold text-lg lg:text-lg prime text-left">
                    {{ course.title.slice(0, 70) }}
                    <span v-if="course.title.length > 70">...</span>
                </h1> 

                  <p>Sections: {{ course.sections.length }}</p> 
                
               

                <div class="flex items-center gap-10 mt-5"> 

                 
                  <div @click="addLessonUnitPopup = true; currentId = course.id"
                  >
                    <img src="@/assets/newd/icon1.svg" alt="Add Course" />
                  </div>

                  <div
                    @click="
                      titlepass = course.title;
                      popupwindow = true;
                      idpass = course.id;
                    "
                    class="cursor-pointer"
                  >
                    <img src="@/assets/newd/icon3.svg" alt="Delete Course" />
                  </div>

                  <router-link
                    :to="{
                      name: 'AdminCoursePreview',
                      params: { course_id: course.id },
                    }"
                    class="cursor-pointer bg-blues text-white px-3 py-1 text-sm font-bold rounded-2xl"
                  >
                    Preview
                  </router-link>

                </div>

                </div>
                
              </div>
            </div>

            

          </div>

         

        </div> -->


      </div>
    </div>

    <div v-if="addCourse" class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"> 
      <NewCourse :batchYear="currentBatchData.id" :departmentName="currentSemesterData.department.id" :programName="currentSemesterData.department.program.id" :semesterName="currentSemesterData.id"  @close-Emit="closeReciveEmit" />
    </div>

    <div v-if="editCoursePopup" class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center">
      <EditCourse :course_id="currentId" :batchYear="currentBatchData.year" :departmentName="currentSemesterData.department.name" :programName="currentSemesterData.department.program.name" :semesterName="currentSemesterData.semester" 
       @close-EmitEdit="closeReciveEmitEdit" />
    </div>

    <div v-if="addLessonUnitPopup" class="fixed z-50 w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0">
      <AddLessonUnit :course_id="currentId" @close-AddUnit="closeReciveEmitAddUnit" />
    </div>
  
   
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";

import Footer from "@/components/Footer.vue";
import { mapGetters } from "vuex";

import axios from "axios";

import NewCourse from "./NewCourse.vue";
import ConfirmPopup from "@/components/ConfirmPopup.vue";
import EditCourse from "./EditCourse.vue";
import AddLessonUnit from "@/components/Common/AddLessonUnit.vue";

export default {
  components: {
    HodHeader,
    CoordinateHeader,
    Header,
    Footer,
    NewCourse,
    ConfirmPopup, 
    EditCourse,
    AddLessonUnit,
    InstructorHeader
  },
  computed: mapGetters(["userInfo"]),

  data() {
    return {
      batchList: [],
      currentBatchData: null,
      semeterList: [],
      currentSemesterData: null,
      courseList: [],
      currentTab: "",
      semesterId: null,
      addCourse: false,
      popupwindow: false,
      editCoursePopup: false,
      currentId: null,
      addLessonUnitPopup: false, 
      loading: false
    };
  },

  created() {
    this.getBatchList();
  },

  methods: {
    
    closeReciveEmitAddUnit(){
      this.addLessonUnitPopup = false;
      this.getSemesterCourses(this.semesterId, this.currentSemesterData);
    },

    closeReciveEmitEdit(){
      this.editCoursePopup = false;
      this.getSemesterCourses(this.semesterId, this.currentSemesterData);
    },

    async deletecourse(data) {
      await axios
        .delete(
          `${process.env.VUE_APP_API}/courseupdate/${data}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          this.res = response;
          if (this.res.statusText == "No Content") {
            this.messages = {
              text: "Deleted successfully",
              type: "success",
            };
            this.getSemesterCourses(this.semesterId, this.currentSemesterData);
            // console.log("successfull");
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });
      this.popupwindow = false;

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 2000);
    },

    closeReciveEmit(){
        this.addCourse = false;
        this.getSemesterCourses(this.semesterId, this.currentSemesterData);
    },

    getBatchList() {
      this.loading = true;
      axios
        .get(
          `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
           this.loading = false;
          if (response.data.status == 200) {
            this.loading = false;
            this.batchList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getSemesterList(id, data) {
        this.semeterList =[];
      this.currentBatchData = data;

      axios
        .get(
          `${process.env.VUE_APP_API}/hod/semesters-list/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.semeterList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },


    getSemesterCourses(id, data) {
        this.courseList =[];
        this.semesterId = id;
      this.currentSemesterData = data;
      axios
        .get(
          `${process.env.VUE_APP_API}/hod/course-list/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.courseList = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

  },
};
</script>

<style></style>
